import axios from 'axios'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
import {
  Message,
  Notification
} from 'element-ui'
import store from '../store/index';
import utils from '@/common/utils/utils'
import $Cookies from 'js-cookie';
import $qs from 'qs';


let reloadIndex = null
let messageFlag = true;

const service = axios.create({
  baseURL: '',
  timeout: 60000, // 超时处理
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  validateStatus: function (status) {
    return status === 200
  }
})

// 错误提示
const showError = function (msg) {
  window.$app.$Notify({
    message: msg || '未知错误',
    type: 'error'
  })
}

//判断请求错误类型
const trans = function (status) {
  switch (status) {
    case 400:
      return '错误的请求';
    case 407:
      return '资源未授权';
    case 403:
      return '登录过期';
    case 404:
      return '资源不存在';
    case 500:
      return '服务出错了';
    case 504:
      return '服务出错了';
    case 502:
      return '服务器暂时不可用';
    case 503:
      return '服务忙';
    case 701: // 无效的授权
      return '登录已过期';
    case 702:
      return '账号未激活';
    case 703:
      return '账号被冻结';
    case 704:
      return '账号已停用';
    case 705:
      return '账号审核失败';
    case 706:
      return '账号被踢出';
    case 707:
      return '非法的授权';
  }
}

// request 拦截
service.interceptors.request.use(
  config => {

    // 是否开启loading条
    // if (config.loading !== false) {
    //   config.loading = true
    //   NProgress.start()
    //   clearInterval(reloadIndex)
    //   reloadIndex = setInterval(() => {
    //     NProgress.inc(0.01)
    //   }, 100)
    // }

    // 是否自动显示错误弹窗反馈, 默认开启
    if (config.showError !== false) {
      config.showError = true
    }

    if (!config.method) config.method = 'post' // 默认为post
    let method = config.method.toLowerCase()

    if (config.headers['Content-Type'] == 'application/x-www-form-urlencoded' && method === 'post') {
      if (config.params) {
        config.params.appType = 'PC';
      }

      config.params = $qs.stringify(config.params)

    }

    if ((method == 'post' || method == 'put') && config.params) {
      config.data = utils.copyObj(config.params)
      config.params = null
    }

    // 设置头部token
    return config
  },
  error => {
    // 关闭loading条
    clearInterval(reloadIndex)
    // NProgress.done()

    return Promise.reject(error)
  }
)

// response 拦截
service.interceptors.response.use(
  res => {
    // 关闭loading条
    clearInterval(reloadIndex)
    // NProgress.done()
    if (res.data.success) {
      res.data.code = res.data.data.code
      res.data.msg = res.data.data.msg
    }
    if (res.request.responseType == 'blob' || res.data.code === 200||res.data.code === 99998) {
      return res.data

    } else {
      if (res.data.code === 99999) {
        setTimeout(function () {
          location.hash = `#/404?err=${res.data.message || res.data.msg}`
        }, 1500)
      }
      if (![201, 500].includes(res.data.code)) { // 过滤不显示提示的code
        if (res.config.showError) {
          showError(res.data.msg)
        }
      }
      if (res.data.code == -1 && res.data.msg.indexOf('未查询到') < 0) {
        // if (res.config.showError) {
        //   showError(res.data.msg)
        // }

      }

      return Promise.reject(res.data)
    }
  },

  error => {
    clearInterval(reloadIndex)
    // NProgress.done()

    if (error.response) {
      let status = error.response.status;
      // 根据状态码，返回错误类型
      error.response.statusText = trans(status);
      if (status === 701 || status === 706 || status === 707) {} else if (status === 500) {
        window.projectMessage = error.response.data.message;
        if (error.response.data.message.indexOf('维护') == -1 || location.hash === '#/500?isShowRound=true') return;
        location.href = `#/500?isShowRound=true`;
        location.reload();
        // window.stop();
        // return;
      } else if (status >= 500) {
        let msg = trans(status);
      } else if (status === 403) { // 登录失效
        store.dispatch('logout').then(res => {
          var parame = window.getParamsByUrl();
          if (!parame.isShowRound) {
            window.$app.$router.push({
              name: 'home'
            })
          }
        })
      }
      if (status === 500) return;
      showError(trans(status))
      //抛出错误给链式catch()
      return Promise.reject(error)
    }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/common/axios/request.js